import { useRouter } from 'next/router';

export function useIsUploadPreview() {
  const { pathname } = useRouter();
  const isPreview = pathname.endsWith('/[releaseId]/step/[stepId]/preview');

  return isPreview;
}
